export const FEED_TYPE = {
  SPECIALTY: "specialty",
  TOPIC: "topic",
};
